import script from "./ChatSidebarBrand.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatSidebarBrand.vue?vue&type=script&setup=true&lang=js"

import "./ChatSidebarBrand.vue?vue&type=style&index=0&id=1d170ac2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d170ac2"]])

export default __exports__